import * as React from 'react';
import { IconProps } from '../types';

const IcPaymentMethod = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        d="M23.352 2.503H2.798a.772.772 0 0 0-.772.772v7.453h-.193c-.942 0-1.709.766-1.709 1.709v7.35c0 .943.767 1.71 1.71 1.71h13.484c.943 0 1.71-.767 1.71-1.71v-4.763h6.324a.772.772 0 0 0 .772-.772V3.275a.772.772 0 0 0-.772-.772Zm-.772 3.042a2.409 2.409 0 0 1-1.498-1.498h1.498v1.498ZM5.068 4.047A2.41 2.41 0 0 1 3.57 5.545V4.047h1.498Zm-3.235 8.225h13.485c.091 0 .165.074.165.165v.728H1.668v-.728c0-.091.074-.165.165-.165ZM9.82 8.764a3.26 3.26 0 0 1 3.256-3.256 3.26 3.26 0 0 1 3.256 3.256c0 .726-.246 1.428-.685 1.995a1.716 1.716 0 0 0-.328-.031h-1.275a1.37 1.37 0 0 0 .407-.976c0-.624-.418-1.152-.989-1.319v-1.12c.132.11.217.276.217.462a.386.386 0 1 0 .772 0c0-.624-.418-1.152-.989-1.32v-.127a.386.386 0 1 0-.772 0v.128c-.57.167-.989.695-.989 1.319s.418 1.152.99 1.319v1.12a.601.601 0 0 1-.217-.462.386.386 0 1 0-.773 0c0 .381.156.726.408.976h-1.63a3.221 3.221 0 0 1-.659-1.964Zm5.664 6.217H1.668v-.787h13.815v.787ZM12.69 8.237a.602.602 0 0 1 0-.924v.924Zm.772 1.977V9.29a.601.601 0 0 1 0 .924Zm1.857 9.739H1.833a.165.165 0 0 1-.165-.166V16.01h13.815v3.777a.165.165 0 0 1-.165.166Zm1.239-8.692a4.295 4.295 0 0 0 .803-2.497 4.29 4.29 0 0 0-4.285-4.286 4.29 4.29 0 0 0-3.81 6.25H3.57V6.614a3.438 3.438 0 0 0 2.567-2.567h13.876a3.438 3.438 0 0 0 2.567 2.567v4.299a3.438 3.438 0 0 0-2.567 2.567h-2.986v-1.043c0-.455-.179-.87-.47-1.176Zm4.525 2.219a2.409 2.409 0 0 1 1.498-1.498v1.498h-1.498Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.124 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcPaymentMethod;
